<!-- Error View -->
<app-module-error *ngIf="noData && !isFirstLoad" [noData]="true"></app-module-error>
<app-module-error class="flex-fill" *ngIf="isTooMuchData" [tooMuchData]="true"></app-module-error>

<div *ngIf="dataLoadSuccess && !noData" class="gridItemChildModule w-100 h-100 d-flex flex-column">
    <!-- Legend Section -->
    <div class="legend-section text-center">
        <div class="legend-item">
            <div class="legend-box schedule-time"></div>
            <span cvLocalizedText langSection="Schedule_Adherence" langKey="Schedule"
                class="lato-regular font-size-12 text-secondary">
                Schedule Time
            </span>
        </div>
        <div class="legend-item">
            <div class="legend-box in-adherence"></div>
            <span cvLocalizedText langSection="Schedule_Adherence" langKey="In_Adherence"
                class="lato-regular font-size-12 text-secondary">
                In Adherence
            </span>
        </div>
        <div class="legend-item">
            <div class="legend-box out-of-adherence"></div>
            <span cvLocalizedText langSection="Schedule_Adherence" langKey="Out_Adherence"
                class="lato-regular font-size-12 text-secondary">
                Out of Adherence
            </span>
        </div>
    </div>

    <!-- Wrapping container to handle sticky headers + vertical scrolling -->
    <div class="table-container">
        <table class="table border-bottom">
            <thead class="border-bottom">
                <tr>
                    <!-- Agent & Adherence columns -->
                    <th cvLocalizedText langSection="Schedule_Adherence" langKey="Agent"
                        class="text-nowrap lato-regular font-size-12 color-theUpsideDown">
                        Agent
                    </th>
                    <th cvLocalizedText langSection="Schedule_Adherence" langKey="Adherence_Percentage"
                        class="text-nowrap lato-regular font-size-12 color-theUpsideDown">
                        Adherence %
                    </th>

                    <!-- TIME HEADERS WRAPPED for potential horizontal scroll -->
                    <!-- If you want the entire table to horizontally scroll, remove the extra .time-columns-scroll wrapper -->
                    <th *ngFor="let time of scheduleTimes; trackBy: trackByTime"
                        class="header-rotate lato-regular font-size-12 color-theUpsideDown time-columns-scroll">
                        {{ time }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let agent of agents; trackBy: trackByAgent">
                    <td class="border-right">
                        <div class="agent">
                            <img [src]="agent.pic" class="agent-icon" />
                            <div class="lato-regular font-size-12 color-theUpsideDown">{{ agent.name }}</div>
                        </div>
                    </td>
                    <td class="text-right border-right align-middle lato-regular font-size-12 color-theUpsideDown">
                        {{ agent.adherence | number:'1.2-2' }}%
                    </td>

                    <td *ngFor="let time of scheduleTimes; trackBy: trackByTime"
                        class="time-column-cell position-relative">
                        <ng-container *ngIf="agent.schedule[time] as timeData">
                            <ng-container *ngIf="getTotalScheduled(timeData) > 0">
                                <div class="border-right" style="height: 5px; width: 100%;"></div>

                                <div class="stacked-bar">
                                    <div class="out-of-adherence-layer"
                                        [style.height.%]="computeOutPercentage(timeData)"
                                        style="bottom: 0;"
                                        [matTooltip]="getOutTooltip(timeData)"
                                        matTooltipPosition="right"
                                        matTooltipClass="my-multiline-tooltip">
                                    </div>
                                    <div class="in-adherence-layer"
                                        [style.height.%]="computeInPercentage(timeData)"
                                        style="top: 0;"
                                        [matTooltip]="getInTooltip(timeData)"
                                        matTooltipPosition="right"
                                        matTooltipClass="my-multiline-tooltip">
                                    </div>
                                </div>

                                <div class="border-right" style="height: 5px; width: 100%;"></div>

                                <div class="schedule-cell">
                                    <div 
                                        class="schedule-time-background"
                                        style="height: 100%;"
                                        [matTooltip]="getScheduleTooltip(timeData)"
                                        matTooltipPosition="right"
                                        matTooltipClass="my-multiline-tooltip">
                                    </div>
                                </div>

                                <div class="border-right" style="height: 5px; width: 100%;"></div>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="!agent.schedule[time]">
                            <div class="border-right" style="height: 57px; width: 100%;"></div>
                        </ng-container>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
